<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section px-0">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8">
        <div class="inner-box">
          <div class="banner-box">
            <img class="rounded-4 h-400 img-row-feedback"
              :src="overview && overview?.main_image && overview?.main_image.length > 0 ? overview.main_image[0].url : ''"
              alt="Logo" />
          </div>
          <div class="inner-content">
            <h3 class="mb-3 mb-sm-4 text-start ml-0 mt-0">
              {{ overview ? overview.heading : "" }}
            </h3>
            <div v-html="overview ? overview.text : ''"></div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4">
        <div class="right-bar">
          <div class="result-detail">
            <div class="left">
              <h4>
                {{
                  overview &&
                    overview?.right_section &&
                    overview?.right_section.length > 0
                    ? overview.right_section[0].heading
                    : ""
                }}
              </h4>
              <div v-html="overview &&
                overview?.right_section &&
                overview?.right_section.length > 0
                ? overview.right_section[0].text
                : ''
                ">
              </div>
              <router-link to="/archaic/results" class="load-btn m-auto">
                {{
                  overview &&
                    overview?.right_section &&
                    overview?.right_section.length > 0
                    ? overview.right_section[0].button_text
                    : ""
                }}
              </router-link>
            </div>
            <div class="percentage-area">
              <div class="progress-wrapper">
                <!--  <svg class="progress-circle" viewBox="0 0 100 100">
                  <circle ref="circle" cx="50" cy="50" r="40"></circle>
                </svg>
                <svg class="progress-bar" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="40"></circle>
                </svg>
                <text class="progress-text" x="50" y="50"> </text> -->
                <!-- <div class="percentage-area"> -->
                <DoughnutChart :chart-data="chartData" ChartColor="rgb(51, 119, 255)"
                  :centerTitle="archaicResult.neanderthal.score" centerSubtitle="" chartWidth="100%" chartHeight="100%"
                  :options="options" class="percentage-area-rowx" />
              </div>
              <!-- </div> -->
            </div>
          </div>

          <div class="population-group">
            <h4>
              {{
                overview && overview?.right_section && overview?.right_section.length > 0
                  ? overview.right_section[1].heading
                  : ""
              }}
            </h4>
            <div v-html="overview && overview?.right_section && overview?.right_section.length > 0
              ? overview.right_section[1].text
              : ''
              "></div>
            <img :src="overview && overview?.right_section && overview?.right_section.length > 0
              ? overview.right_section[1].main_image[0].url
              : ''
              " />
            <router-link to="/archaic/maps" class="load-btn m-auto">{{
              overview && overview?.right_section && overview?.right_section.length > 0
                ? overview.right_section[1].button_text
                : ""
            }}
            </router-link>
          </div>
          <div class="population-group">
            <h4>
              {{
                overview && overview?.right_section && overview?.right_section.length > 0
                  ? overview.right_section[2].heading
                  : ""
              }}
            </h4>
            <div v-html="overview && overview?.right_section && overview?.right_section.length > 0
              ? overview.right_section[2].text
              : ''
              "></div>
            <img :src="overview && overview?.right_section && overview?.right_section.length > 0
              ? overview.right_section[2].main_image[0].url
              : ''
              " />
            <router-link to="/archaic/traits" class="load-btn m-auto">{{
              overview && overview?.right_section && overview?.right_section.length > 0
                ? overview.right_section[2].button_text
                : ""
            }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import "../../styles/pages/ancentry/recent-ancetry.scss";
import "../../styles/pages/ancentry/neanderthal-main.scss";
import { getArchaicIntroduction } from "@/services/archaic";
import { ref, onMounted, watch } from "vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
import { getClosestSampleInfo } from "@/services/archaic";
export default {
  name: "ArchaicOverview",
  components: {
    DoughnutChart
  },
  props: {
    archaicResult: Object,
  },
  setup(props) {
    const loadingStatus = ref("loading");
    const overview = ref({});
    const closestSampleInfo = ref({});
    const options = {
      cutout: "70%",
      radius: "100%",
      responsive: true,
    };
    onMounted(async () => {
      overview.value = await getArchaicIntroduction();
      watch(
        () => props.archaicResult.neanderthal.closest_sample.slug,
        async () => {
          closestSampleInfo.value = await getClosestSampleInfo(
            props.archaicResult.neanderthal.closest_sample.slug
          );
        },
        { immediate: true }
      );
      loadingStatus.value = "loaded";
    });
    return { loadingStatus, overview, options, closestSampleInfo };
  },
  computed: {
    chartData() {
      return {
        datasets: [
          {
            data: [
              this.archaicResult.neanderthal.score,
              500 - this.archaicResult.neanderthal.score,
            ],
            backgroundColor: ["rgb(51, 119, 255)", "#ddd"],
          },
        ],
        labels: [],
      };
    },
  },
};
</script>
